module.exports = __webpack_public_path__ + "static/logo.top-529742e3cc70c6a8da557ea07d28f473.png";